export const getExistingLoanAction = (state = [], action) => {
  switch (action.type) {
    case "GET_EXISTING_LOAN_DETAILS":
      return action.data;

    default:
      return state;
  }
};
